import { z } from 'zod';
import type { TFunction } from 'i18next';

const createQuestionariesFormSchema = (t: TFunction) => {
  const required = t('authPages.validation.requiredField');

  return z.object({
    questions: z
      .array(
        z.object({
          questionId: z.string().min(1, { message: required }),
          selectedAnswers: z
            .array(z.string())
            .min(1, { message: required })
            .refine(
              answers => answers.every(answer => answer.trim().length > 0),
              { message: required }
            ),
        })
      )
      .min(1, { message: required }),
  });
};

type QuestionariesFormValues = z.infer<
  ReturnType<typeof createQuestionariesFormSchema>
>;

export { createQuestionariesFormSchema, type QuestionariesFormValues };
